import Maps from "./Maps";
export default Maps;